import FactoryCards from '../../components/organisms/FactoryCards';

function Factory({title}) {
    return (
        <div className='factory-container'>
            <FactoryCards />
        </div>
    );
}
export default Factory;
